/* eslint-disable no-unused-vars */
import { LengthUnit } from "@colibrio/colibrio-reader-framework/colibrio-core-base";
import type {ICirrusReaderPublicationStyleOptions} from "./CirrusReaderModel";
import { RendererType } from "../../../../app/configuration/types";

export enum CirrusReaderUiActionNames {
    NAVIGATE_NEXT= 'uiaction_navigate_next',
    NAVIGATE_PREVIOUS= 'uiaction_navigate_previous',
}
export interface ICirrusReaderUiActionKeyCommand {
    actionName: CirrusReaderUiActionNames;
    key: string;
    modifiers: Key[];
}

export interface ICirrusReaderUiOptionsData {
    _id?: number,
    dateCreated?: number;
    showNarrationControls?: boolean;
    ignoreAspectRatio?: boolean;
    useReducedMotion?: boolean;
    useDarkMode?: boolean;
    activeRendererTypeName?: RendererType;
    activeUiPaletteName?: string,
    activePublicationPaletteName?: string;
    activePublicationFontSetName?: string;
    publicationStyleOptions?: ICirrusReaderPublicationStyleOptions;
    mediaPlayerPlaybackRate?: number;
    useAccessibilityMode?: boolean;
    showPageNumbers?: boolean;
    scrollOverflowingTables?: boolean;
    uIActionKeyCommands?: ICirrusReaderUiActionKeyCommand[],
}


export const CirrusReaderAppUiDefaults = () => {
    const _options: ICirrusReaderUiOptionsData = {
        publicationStyleOptions: {
            fontSet: null,
            fontSizeScaleFactor: 1,
            lineHeightScaleFactor: 1.2,
            wordSpacing: null,
            letterSpacing: null,
            textAlignment: null,
            removePublicationDefinedHorizontalPageMargins: true,
            resetPublicationDefinedTypography: false,
            pageMargins: {
                top: {
                    unit: LengthUnit.PERCENT,
                    value: 6,
                },
                bottom: {
                    unit: LengthUnit.PERCENT,
                    value: 6,
                },
                left: {
                    unit: LengthUnit.PERCENT,
                    value: 6,
                },
                right: {
                    unit: LengthUnit.PERCENT,
                    value: 6,
                },
            },
        },
        dateCreated: undefined,
        showNarrationControls: false,
        useAccessibilityMode: false,
        ignoreAspectRatio: false,
        useReducedMotion: false,
        useDarkMode: false,
        activeRendererTypeName: RendererType.enum.__responsive__,
        activeUiPaletteName: 'Default',
        activePublicationFontSetName: 'default',
        activePublicationPaletteName: 'Default',
        mediaPlayerPlaybackRate: 1,
        showPageNumbers: true,
        scrollOverflowingTables: false,
        uIActionKeyCommands: [
            {
                actionName: CirrusReaderUiActionNames.NAVIGATE_NEXT,
                key: 'ArrowRight',
                modifiers: [Key.Alt]
            },
            {
                actionName: CirrusReaderUiActionNames.NAVIGATE_PREVIOUS,
                key: 'ArrowLeft',
                modifiers: [Key.Alt]
            },
        ],
    };

    return {
        options: _options
    }

}
